import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import Button from '../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { EmployeeSkillsRadar } from '../radarChart/EmployeeSkillsRadar';
import { EmployeeSkillsSidebar } from './EmployeeSkillsSidebar';

type Props = {
  employeeId: string;
  employeeName: string;
};

export const EmployeeSkillsCard: React.FC<React.PropsWithChildren<Props>> = ({
  employeeId,
  employeeName,
}) => {
  const t = useNamespacedTranslation('skills.employeeSkillCard');
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(false);

  const handleViewAllClick = () => {
    setSidebarVisible(true);
  };

  const handleSidebarClose = () => {
    setSidebarVisible(false);
  };

  return (
    <>
      <Card>
        <Card.Header className="d-flex justify-content-between">
          <div className="fw-bold">{t('header')}</div>
          <Button
            label={t(`viewAll`)}
            size="sm"
            variant="outline-primary"
            onClick={handleViewAllClick}
          />
        </Card.Header>
        {/* Roughly square by default: the radar chart and the "select more
            skills" states are short, and without a floor the card collapses to
            a thin strip next to the target profile. */}
        <Card.Body
          className="d-flex flex-column"
          style={{ minHeight: '28rem' }}>
          <EmployeeSkillsRadar employeeId={employeeId} />
        </Card.Body>
      </Card>
      <EmployeeSkillsSidebar
        visible={sidebarVisible}
        employeeId={employeeId}
        employeeName={employeeName}
        onClose={handleSidebarClose}
      />
    </>
  );
};
